/* eslint-disable no-unused-vars */
import {MatchV2} from './match_v2';
import {Season} from './season';
import {Standing} from './standing';

/**
 * Tipos de fase
 */
export enum StageType {
  LEAGUE = 'LEAGUE',
  GROUP = 'GROUP',
  KNOCKOUT = 'KNOCKOUT',
}

export type Stage = {
  uuid: string;
  season_uuid?: string;
  season?: Season;
  is_main_widget: boolean;
  name: string;
  type: StageType;
  current_round?: number;
  stage_order: number;
  group_name?: string;
  direct_qualifiers_count?: number;
  playoff_qualifiers_count?: number;
  secondary_qualifiers_count?: number;
  relegated_count?: number;
  direct_qualifiers_label?: string | null;
  playoff_qualifiers_label?: string | null;
  secondary_qualifiers_label?: string | null;
  relegated_qualifiers_label?: string | null;
  standings?: Standing[];
  matches?: MatchV2[];
  created_at: string;
  updated_at: string;
};
